module.exports = "./img/4c5e3e2543bb18491aa92fb2de0620a8.png";